export default (noScrollOn) => {
  const body = document.querySelector('body');

  if (noScrollOn) {
    body.classList.add('b-no-scroll');
  } else {
    body.classList.remove('b-no-scroll');
  }
}
